import { device } from 'monica-alexandria';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Steps_Progress } from './Steps_Progress';

const Steps = styled.div`
    height: calc(100vh - 6rem);
    position: fixed;
    top: 6rem;
    left: 0;
    width: 30rem;
    border-right: 0.2rem solid ${p => p.theme.low};
    background: ${p => p.theme.background};
`;

const StepsList = styled.ul``;

const StepsBox = styled.li`
    padding: 1rem 2rem 1rem 4rem;
    cursor: ${p => p.started ? 'pointer' : 'default'};
    pointer-events: ${p => p.started ? 'normal' : 'none'};
    transition: background 0.5s;
    border-bottom: 0.2rem solid ${p => p.active ? p.theme.mid : p.theme.low};
    background: ${p => p.active ? p.theme.low : 'transparent'};
    opacity: ${p => p.started ? '1' : '.5'};

    @media ${device.md} {
        padding-left: 2rem;
    }

    &:hover {
        background: ${p => p.started ? p.theme.mid : 'transparent'};
        transition: background 0.5s;
    }
`;

export const Steps_ = (props) => {
    const { t } = useTranslation();

    return (
        <Steps>
            <StepsList>
                <StepsBox
                    started={props.step >= 0}
                    active={props.step >= 0 && props.step < 2}
                    onClick={() => props.setStep(0)}
                >
                    <h5>{t('Setup')}</h5>
                    <Steps_Progress
                        currentStep={Math.min(2, Math.max(0, props.step))}
                        totalSteps={2}
                    />
                </StepsBox>
                {!props.setupOnly ? (
                    <>
                        <StepsBox
                            started={props.step >= 2}
                            active={props.step >= 2 && props.step < 3}
                            onClick={() => props.setStep(2)}
                        >
                            <h5>{t('Commercials')}</h5>
                            <Steps_Progress
                                currentStep={Math.min(1, Math.max(0, props.step - 1))}
                                totalSteps={1}
                            />
                        </StepsBox>
                        <StepsBox
                            started={props.step >= 3}
                            active={props.step >= 3 && props.step < 4}
                            onClick={() => props.setStep(3)}
                        >
                            <h5>{t('Final review')}</h5>
                            <Steps_Progress
                                currentStep={Math.min(1, Math.max(0, props.step - 2))}
                                totalSteps={1}
                            />
                        </StepsBox>
                    </>
                ) : null}
            </StepsList>
        </Steps>
    );
};
